import { memo } from 'react';
import { IContent } from 'src/interface';
import { ContentTime } from './ContentTime';
import { ContentPublisher } from './ContentPublisher';

interface IProps {
    content: IContent;
    displayTimeIn?: number;
}

export function ContentFooter(props: IProps) {
    const { content, displayTimeIn } = props;
    return (
        <>
            <ContentPublisher publisher={content.publisher} {...props} />
            <ContentTime date={content.date} displayTimeIn={displayTimeIn} />
        </>
    );
}

export default memo(ContentFooter);
